import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatPanelWrapper = createCustomElementWrapper('kat-panel-wrapper', 'KatPanelWrapper', {
    'maskBackground': 'mask-background',
    'panelVisible': 'panel-visible',
}, {}, [
    'panel',
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/panel-wrapper.js
// module id = 1243
// module chunks = 0